export type Tone = "primary" | "accent" | "secondary";

export interface ToneClasses {
  bgSoft: string;
  textStrong: string;
  textSoft: string;
  solid: string;
  border: string;
  dot: string;
  ring: string;
}

export const toneClasses: Record<Tone, ToneClasses> = {
  primary: {
    bgSoft: "bg-primary-100",
    textStrong: "text-primary-800",
    textSoft: "text-primary-700",
    solid: "bg-primary-500",
    border: "border-primary-200",
    dot: "bg-primary-500",
    ring: "ring-primary-300",
  },
  accent: {
    bgSoft: "bg-accent-100",
    textStrong: "text-accent-900",
    textSoft: "text-accent-800",
    solid: "bg-accent-500",
    border: "border-accent-200",
    dot: "bg-accent-500",
    ring: "ring-accent-300",
  },
  secondary: {
    bgSoft: "bg-secondary-100",
    textStrong: "text-secondary-900",
    textSoft: "text-secondary-800",
    solid: "bg-secondary-500",
    border: "border-secondary-200",
    dot: "bg-secondary-500",
    ring: "ring-secondary-300",
  },
};

export const formatViews = (n: number): string =>
  n >= 10000 ? `${(n / 10000).toFixed(1)}万` : `${n}`;

export const formatDateCN = (dateStr: string): string => {
  const [y, m, d] = dateStr.split("-");
  return `${y}年${Number(m)}月${Number(d)}日`;
};

export const formatDateShort = (dateStr: string): string => {
  const parts = dateStr.split("-");
  return `${parts[1]}/${parts[2]}`;
};